import { v4 as uuid } from 'uuid';
import React, { createContext, useCallback, useEffect, useState, useRef, } from 'react';
import { viewportManager } from '@iot-app-kit/core';
export const ViewportContext = createContext({
    setViewport: () => { },
    group: uuid(),
});
export const DEFAULT_VIEWPORT = {
    duration: '10m', // default viewport
};
export const TimeSync = ({ group, initialViewport, children, }) => {
    const [viewport, setViewport] = useState(initialViewport || DEFAULT_VIEWPORT);
    const [lastUpdatedBy, setLastUpdatedBy] = useState();
    // Fall back unique viewport group, only used if `group` is not defined.
    const autoGeneratedGroup = useRef(uuid());
    const updateViewportGroup = useCallback((v, lastUpdatedBy) => {
        viewportManager.update(group !== null && group !== void 0 ? group : autoGeneratedGroup.current, v, lastUpdatedBy);
        setLastUpdatedBy(lastUpdatedBy);
    }, [group]);
    useEffect(() => {
        const { viewport, unsubscribe } = viewportManager.subscribe(group !== null && group !== void 0 ? group : autoGeneratedGroup.current, (v) => setViewport(v));
        // Set initial viewport
        if (viewport) {
            setViewport(viewport);
        }
        else {
            updateViewportGroup(initialViewport || DEFAULT_VIEWPORT);
        }
        return unsubscribe;
    }, [group, initialViewport, updateViewportGroup]);
    return (React.createElement(ViewportContext.Provider, { value: {
            setViewport: updateViewportGroup,
            viewport,
            group: group !== null && group !== void 0 ? group : autoGeneratedGroup.current,
            lastUpdatedBy,
        } }, children));
};
